<template>
  <div class="d-flex mt-3 p-relative" :style="{ height }">
    <v-tooltip top color="dark" v-for="item in result.details" :key="item.key">
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
          :class="['p-relative z-index-2', item.key]"
          :style="{ width: item.rate + '%' }"
        ></div>
        <div class="empty p-absolute z-index-1"></div>
      </template>
      <span>{{ item.displayName }}: {{ item.rate }}%</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    result: Object,
    height: {
      type: String,
      default: "30px",
    },
  },
};
</script>

<style lang="scss" scoped>
.yes {
  background-color: var(--green);
}
.no {
  background-color: rgb(238, 103, 103);
}
.abstain {
  background-color: var(--gray);
}
.no_with_veto {
  background-color: var(--purple);
}
.empty {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--lightgray);
}
</style>
